"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var DefaultText = function (_a) {
    var style = _a.style, paymentData = _a.paymentData;
    var _b;
    var intl = react_intl_1.useIntl();
    return (<>
      <core_1.Typography component="h2" variant="body1" data-test="text:payment:subTitle" className={style.subTitle}>
        <react_intl_1.FormattedMessage id="payment.successful.subtitle"/>
      </core_1.Typography>
      {((_b = paymentData) === null || _b === void 0 ? void 0 : _b.amount) && (<core_1.Typography component="div" variant="body1" data-test="text:payment:description" className={style.paragraph}>
          <react_intl_1.FormattedMessage id="payment.successful.description1" values={{
        reservationFee: paymentData.amount,
    }}/>
        </core_1.Typography>)}
      <core_1.Typography component="div" variant="body1" data-test="text:payment:description2" className={style.paragraph}>
        <react_intl_1.FormattedMessage id="payment.successful.description2" values={{
        phoneNumber: (<a href={"tel:" + intl.formatMessage({ id: 'payment.phoneNumber' })}>
                <react_intl_1.FormattedMessage id="payment.phoneNumber" defaultMessage=" "/>
              </a>),
        email: (<a href={"mailto:" + intl.formatMessage({ id: 'payment.email' })}>
                <react_intl_1.FormattedMessage id="payment.email" defaultMessage=" "/>
              </a>),
    }}/>
      </core_1.Typography>
      <core_1.Typography component="div" variant="body1" data-test="text:payment:description3" className={style.paragraph}>
        <react_intl_1.FormattedMessage id="payment.successful.description3" values={{
        disclaimerLink: (<a href={"" + intl.formatMessage({ id: 'payment.disclaimerLink' })} target="_blank" rel="noreferrer">
                <react_intl_1.FormattedMessage id="payment.disclaimerCta" defaultMessage=" "/>
              </a>),
    }}/>
      </core_1.Typography>
      <core_1.Typography component="div" variant="body1" data-test="text:payment:description4" className={clsx_1.default(style.paragraph, style.highlighted)}>
        <react_intl_1.FormattedMessage id="payment.successful.description4" values={{
        phoneNumber: (<a href={"tel:" + intl.formatMessage({ id: 'label.getInTouch.phoneNumber' })}>
                <react_intl_1.FormattedMessage id="label.getInTouch.phoneNumber"/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = DefaultText;
